import {
  Component,
  HostBinding,
  Input
} from '@angular/core';

import { PositionEnum } from '../../../_enums/position.enum';
import { SdTitleComponent } from '../../title/title.component';
import { SdHtmlComponent } from '../../html/html.component';

@Component({
  selector: 'sd-border-wrapper',
  templateUrl: './border-wrapper.component.html',
  standalone: true,
  imports: [
    SdTitleComponent,
    SdHtmlComponent
  ]
})
export class SdBorderWrapperComponent {
  @Input()
  title: string;

  @Input()
  subTitle: string;

  @Input()
  subTitleLevel: string;

  @Input()
  hasBorder = true;

  @Input()
  customClass: string;

  @Input()
  titleLevel: number;

  @Input()
  description: string;

  @Input()
  textConfig: PositionEnum.left | PositionEnum.right | PositionEnum.center =
    PositionEnum.left;

  @Input()
  isReinsurance = false;

  @Input() class = '';

  @Input()
  hasBorderTop = false;

  @HostBinding('class')
  get hostClasses(): string {
    return [
      this.class,
      this.title || this.description || this.subTitle ? '' : 'has-no-data',
      this.isReinsurance ? 'is-reinsurance' : '',
      this.hasBorder ? 'has-border' : '',
      this.hasBorderTop ? 'has-border-top' : ''
    ]
      .filter(Boolean)
      .join(' ');
  }
}
